import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { UploadDialogComponent } from 'src/app/admin/manage-personas/edit/upload-dialog/upload-dialog';
import { WorkspaceDocsCollectionsService } from '@workspaces/services/document.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UploadLinksResponse } from '@workspaces/models/documents';
import { LoaderButtonComponent } from '../loader-button/loader-button.component';
import { SUPPORTED_EXTENSIONS } from '@workspaces/utils/supported-extensions';
import { FileSelectorComponent } from '../file-selector/file-selector.component';

export interface UploadFileTile {
  file: File;
  name: string;
}
@Component({
  selector: 'app-upload-source-docs',
  templateUrl: './upload-source-docs.component.html',
  styleUrls: ['./upload-source-docs.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, CommonModule, LoaderButtonComponent, FileSelectorComponent]
})
export class UploadSourceDocsComponent implements OnDestroy {
  public files: UploadFileTile[] = [];
  public isSubmitting = false;
  public readonly supportedFileExtensions = SUPPORTED_EXTENSIONS;
  private readonly sub = new Subscription();
  constructor(
    public readonly dialogRef: MatDialogRef<UploadDialogComponent>,
    public readonly workspaceDocsCollectionsService: WorkspaceDocsCollectionsService,
    @Inject(MAT_DIALOG_DATA) private readonly workspaceId: string,
    private readonly http: HttpClient
  ) {}

  onFilesChanged(files: File[]): void {
    this.files = files.map(file => ({ file, name: file.name }));
  }

  onSave(): void {
    this.isSubmitting = true;
    this.sub.add(
      this.workspaceDocsCollectionsService
        .getUploadUrls(this.workspaceId, { files: this.files.map(f => f.name) })
        .subscribe(async urls => {
          const filesWithUrls = this.matchFilesToUrls(urls);
          await Promise.all(
            filesWithUrls.map(fileWithUrl => {
              return this.uploadToS3(fileWithUrl);
            })
          );
          this.isSubmitting = false;
          this.dialogRef.close();
        })
    );
  }

  matchFilesToUrls(urls: UploadLinksResponse) {
    const filesWithUrls: { file: File; url: string }[] = [];
    urls.links.forEach(link => {
      const uploadFile = this.files.find(file => file.name === link.file_name);
      if (uploadFile) {
        filesWithUrls.push({ file: uploadFile.file, url: link.url });
      }
    });
    return filesWithUrls;
  }

  uploadToS3(uploadFileWithUrl: { file: File; url: string }) {
    return firstValueFrom(
      this.http.put(uploadFileWithUrl.url, uploadFileWithUrl.file, {
        headers: new HttpHeaders({
          'Content-Type': uploadFileWithUrl.file.type
        })
      })
    );
  }

  onCancel(): void {
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
